import { render, staticRenderFns } from "./ClientAccountTypeEdit.vue?vue&type=template&id=5fdf78d3&"
import script from "./ClientAccountTypeEdit.vue?vue&type=script&lang=js&"
export * from "./ClientAccountTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports